import { createFileRoute } from '@tanstack/react-router';
import { RelatorioFinanceiroDre } from '@/features/relatorio/page/financeiro/dre/RelatorioFinanceiroDre';

export const Route = createFileRoute('/a/relatorio/financeiro/dre')({
    component: RelatorioFinanceiroDre,
});
